module.exports = __webpack_public_path__ + "static/media/twitter_black.176b62a1.svg";